/**
 * Validates if a quotation is ready for Yappy payment processing
 *
 * @param {Object} quoteData - Quote header data
 * @returns {Object} Validation result with isValid flag and error messages
 */
import { regexEmail } from 'Utils/constants'

export const validateQuoteForYappyPayment = quoteData => {
  const errors = []

  // Validate customer email (required for Yappy payment notifications)
  // EmailAddress y CustomerEmail son sinónimos usados de forma intercambiable
  // en el resto de la app (ver EditarCotizacion.jsx); se revisan ambos para no
  // depender de cuál de los dos quedó poblado en cada ruta de carga.
  const customerEmail = quoteData.EmailAddress || quoteData.CustomerEmail
  if (!customerEmail || customerEmail.trim() === '') {
    errors.push('Se requiere email del cliente para pago con Yappy')
  } else if (!regexEmail.test(customerEmail)) {
    errors.push('El email del cliente no es válido')
  }

  // Validate amount
  if (!quoteData.AmountWithTax || quoteData.AmountWithTax <= 0) {
    errors.push('El monto debe ser mayor a cero')
  }

  // Validate products
  if (!quoteData.Lines || quoteData.Lines.length === 0) {
    errors.push('La cotización debe tener al menos un producto')
  }

  // Validate customer
  if (!quoteData.CustomerId) {
    errors.push('Se requiere cliente asociado a la cotización')
  }

  // Validate customer name
  if (
    !quoteData.CustomerNameDocument ||
    quoteData.CustomerNameDocument.trim() === ''
  ) {
    errors.push('Se requiere nombre del cliente')
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

/**
 * Checks if a payment is confirmed
 *
 * @param {Object} quoteData - Quote header data
 * @returns {boolean} True if payment is confirmed
 */
export const isPaymentConfirmed = quoteData => {
  return quoteData?.PaymentStatus === 'confirmed'
}
